import { platformConfiguration } from "application/platformConfiguration";
import { Navigate, Outlet } from "react-router-dom";
import { useFeatureFlag } from "ui/hooks/useFeatureFlag";
import { usePaths } from "ui/hooks/usePaths";
import { useTypedSelector } from "ui/hooks/useTypeSelector";

export const NotLoggedOutlet = () => {
  const { authorized } = useTypedSelector((state) => state.auth);
  const { mainRedirectPath } = usePaths();
  const { isFederatedSignUp, isRegularSignUp } = useTypedSelector(
    (state) => state.registration
  );
  const { isProjectsOnly } = useFeatureFlag();

  if (
    (authorized && isProjectsOnly && isFederatedSignUp) ||
    (authorized && isProjectsOnly && isRegularSignUp)
  ) {
    return (
      <Navigate
        to={"/" + platformConfiguration.defaultWelcomePagePath}
        replace
      />
    );
  }

  return authorized ? <Navigate to={mainRedirectPath} replace /> : <Outlet />;
};
